import apiService from './apiService'

export default apiService
